const storesEmails = {
  // buttertree: ["jonethan@atomic-growth.com"],
  rushmorerose: ["motim@atomic-growth.com"],
  vos: ["eli@atomic-growth.com"],
  atlasonix: ["alex@atomic-growth.com", "juan@atomic-growth.com"],
  // trueocity: ["lihi@atomic-growth.com"],
  AmazonWallDisplay: ["amazon@atomic-growth.com"],
  roofpax: ["hilit@atomic-growth.com"],
};

const storeToOwnerEmail = {
  atlasonix: ["shira@atomic-growth.com", "juan@atomic-growth.com"],
  buttertree: ["lihi@atomic-growth.com"],
  vos: ["lihi@atomic-growth.com"],
  trueocity: ["lihi@atomic-growth.com"],
  rushmorerose: ["motim@atomic-growth.com", "idan@ppc4us.com"],
  garnetics: ["motim@atomic-growth.com", "idan@ppc4us.com"],
  volko: [
    "boaz@atomic-growth.com",
    "danielleb@atomic-growth.com",
    "juan@atomic-growth.com",
    "eyals@atomic-growth.com",
    "jonethan@atomic-growth.com",
  ],
  duramont: [
    "boaz@atomic-growth.com",
    "danielleb@atomic-growth.com",
    "eyals@atomic-growth.com",
    "motim@atomic-growth.com",
  ],
  yogi: ["shira@atomic-growth.com"],
  roofpax: ["hilit@atomic-growth.com"],
  cleveryoga: ["clientsadmin@atomic-growth.com"],
  sugarplum: ["clientsadmin@atomic-growth.com"],
  artori: ["clientsadmin@atomic-growth.com"],
  petpace: ["clientsadmin@atomic-growth.com"],
  tyrolerbrighttools: ["clientsadmin@atomic-growth.com"],
  mainstream: ["clientsadmin@atomic-growth.com"],
  milliwaysusa: ["clientsadmin@atomic-growth.com"],
  vnscreations: ["clientsadmin@atomic-growth.com"],
};
const storeNames = [
  {
    value: "all",
    label: "All stores",
  },
  {
    value: "atlasonix",
    label: "Atlasonix",
    euMarketplaces: true,
  },
  {
    value: "atomicuk",
    label: "Atomic UK",
    euMarketplaces: true,
    ukOnly: true,
  },
  {
    value: "buttertree",
    label: "Buttertree",
  },
  {
    value: "duramont",
    label: "Duramont",
  },
  {
    value: "garnetics",
    label: "Garnetics",
  },
  {
    value: "rushmorerose",
    label: "Rushmore Rose",
  },
  {
    value: "trueocity",
    label: "Trueocity",
  },
  {
    value: "vos",
    label: "Vos",
  },
  {
    value: "volko",
    label: "VolkGo",
  },
  {
    value: "yogi",
    label: "YoGi",
  },
  {
    value: "roofpax",
    label: "RoofPax",
  },
];

// TODO: replace with a backend API call — fetch eu_marketplace_ids from the
// store's AppConfig via a store overview endpoint instead of hardcoding here.
const storesWithEuMarketplaces = storeNames
  .filter((s) => s.euMarketplaces)
  .map((s) => s.value);

// Stores that only sell on the UK marketplace — the marketplace picker
// should offer just the UK flag instead of the usual US/CA(/UK) set.
const storesUkOnly = storeNames.filter((s) => s.ukOnly).map((s) => s.value);

const AuthorizedStores = (email) => {
  if (
    email &&
    // (email === "angel@atomic-growth.com" ||
    email === "ditchsy@atomic-growth.com"
  ) {
    return [{ value: "buttertree", label: "Buttertree" }];
  } else if (
    email === "clients@atomic-growth.com" ||
    email === "clientsadmin@atomic-growth.com"
  ) {
    return [
      {
        value: "all",
        label: "All stores",
      },
      {
        value: "cleveryoga_client",
        label: "Clever Yoga",
        is_client: true,
      },
      {
        value: "amzbrands_client",
        label: "AMZ Brands",
        is_client: true,
      },
      {
        value: "joyful_client",
        label: "Joyful Artistry",
        is_client: true,
      },
      {
        value: "sugarplum_client",
        label: "Sugar Plum Chocolates",
        is_client: true,
      },
      {
        value: "yugibaby_client",
        label: "Yugi Baby Green",
        is_client: true,
      },
      {
        value: "artori_client",
        label: "Artori Design",
        is_client: true,
      },
      {
        value: "petpace_client",
        label: "Petpace",
        is_client: true,
      },
      {
        value: "tyrolerbrighttools_client",
        label: "Tyroler Bright Tools",
        is_client: true,
      },
      {
        value: "mainstream_client",
        label: "Mainstream",
        is_client: true,
      },
      {
        value: "milliwaysusa_client",
        label: "Milliways USA",
        is_client: true,
      },
      {
        value: "vnscreations_client",
        label: "VNS Creations",
        is_client: true,
      },
    ];
  } else if (email === "neil@sugar-plum.com") {
    return [
      {
        value: "sugarplum_client",
        label: "Sugar Plum Chocolates",
        is_client: true,
      },
    ];
  } else if (email === "alfonso.sansimon@volcanbrands.com") {
    return [
      {
        value: "cleveryoga_client",
        label: "Clever Yoga",
        is_client: true,
      },
    ];
  } else if (email.includes("ea-brands.com")) {
    return [
      {
        value: "amzbrands_client",
        label: "AMZ Brands",
        is_client: true,
      },
    ];
  } else if (email.includes("miko.amzn@gmail.com")) {
    return [
      {
        value: "joyful_client",
        label: "Joyful Artistry",
        is_client: true,
      },
    ];
  } else if (email === "info@ppc4us.com") {
    return [
      {
        value: "sugarplum_client",
        label: "Sugar Plum Chocolates",
        is_client: true,
      },
      {
        value: "artori_client",
        label: "Artori Design",
        is_client: true,
      },
      {
        value: "petpace_client",
        label: "Petpace",
        is_client: true,
      },
    ];
  } else if (email === "mica001@atomic-growth.com") {
    return [
      {
        value: "cleveryoga_client",
        label: "Clever Yoga",
        is_client: true,
      },
      {
        value: "amzbrands_client",
        label: "AMZ Brands",
        is_client: true,
      },
      {
        value: "joyful_client",
        label: "Joyful Artistry",
        is_client: true,
      },
      {
        value: "sugarplum_client",
        label: "Sugar Plum Chocolates",
        is_client: true,
      },
      {
        value: "all",
        label: "All stores",
      },
      {
        value: "atlasonix",
        label: "Atlasonix",
      },
      {
        value: "buttertree",
        label: "Buttertree",
      },
      {
        value: "duramont",
        label: "Duramont",
      },
      {
        value: "garnetics",
        label: "Garnetics",
      },
      {
        value: "rushmorerose",
        label: "Rushmore Rose",
      },
      {
        value: "trueocity",
        label: "Trueocity",
      },
      {
        value: "vos",
        label: "Vos",
      },
      {
        value: "volko",
        label: "VolkGo",
      },
      {
        value: "yogi",
        label: "YoGi",
      },
      {
        value: "roofpax",
        label: "RoofPax",
      },
    ];
  }
  return storeNames;
};

// Agent recommendations are Atomic's own analysis of a seller's catalogue, so
// they are shown to Atomic staff only. Matching the domain after the "@" rather
// than anywhere in the address keeps an attacker-chosen address such as
// "x@atomic-growth.com.example.net" out.
const ATOMIC_DOMAINS = ["atomic-growth.com", "atomic-one.com"];

const isAtomicUser = (email) =>
  typeof email === "string" &&
  ATOMIC_DOMAINS.some((domain) => email.toLowerCase().endsWith(`@${domain}`));

const filters = [
  {
    value: "",
    label: "None",
  },
  {
    value: 1,
    label: "1 star",
  },
  {
    value: 2,
    label: "2 star",
  },
  {
    value: 3,
    label: "3 star",
  },
  {
    value: 4,
    label: "4 star",
  },
  {
    value: 5,
    label: "5 star",
  },
  {
    value: "v-1",
    label: "verified purchase",
  },
]; // file: AllReviews.js

const sort_by_list = [
  {
    value: "",
    label: "None",
  },
  {
    value: "1",
    label: "date_utc ascending",
  },
  {
    value: "2",
    label: "date_utc descending",
  },
  {
    value: "3",
    label: "helpful_votes ascending",
  },
  {
    value: "4",
    label: "helpful_votes descending",
  },
]; // file: AllReviews.js

const presets = [
  "Today",
  "Yesterday",
  "Last 7 days",
  "Last 30 days",
  "Last 90 days",
  "Last month",
  "Last 12 months",
  "Last year",
  "Week to date",
  "Month to date",
]; //file: shared/DatePicker/helper.js

const dateRanges = [
  {
    value: 1,
    label: "Custom",
  },
  {
    value: 2,
    label: "Today",
  },
  {
    value: 3,
    label: "Last 30 days",
  },
  {
    value: 4,
    label: "Last 12 months",
  },
  {
    value: 5,
    label: "Last 7 days",
  },
  {
    value: 6,
    label: "Last 14 days",
  },
  {
    value: 7,
    label: "Last 90 days",
  },
]; // file: StoreAnalysis/Datepicker.js

const compareToValues = [
  {
    value: 1,
    label: "Previous period",
  },
  {
    value: 2,
    label: "Previous year",
  },
]; // file: StoreAnalysis/Datepicker.js

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]; // file: StorePlanning/GoalsTable.js and StoreProducts/TableRow.js

const labels = [
  ["S", "01"],
  ["S", "02"],
  ["M", "03"],
  ["T", "04"],
  ["W", "05"],
  ["T", "06"],
  ["F", "07"],
  ["S", "08"],
  ["S", "09"],
  ["M", "10"],
  ["T", "11"],
  ["W", "12"],
  ["T", "13"],
  ["F", "14"],
  ["S", "15"],
  ["S", "16"],
  ["M", "17"],
  ["T", "18"],
  ["W", "19"],
  ["T", "20"],
  ["F", "21"],
  ["S", "22"],
  ["S", "23"],
  ["M", "24"],
  ["T", "25"],
  ["W", "26"],
  ["T", "27"],
  ["F", "28"],
  ["S", "29"],
  ["S", "30"],
]; //file: StorePlanning/store_planning.js

const actualData = [
  1000, 1500, 1400, 1700, 1500, 1500, 2100, 1700, 2000, 1200, 1600, 1400, 1500,
  1000, 1200, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]; //file: StorePlanning/store_planning.js
const forecastData = [
  1000, 1500, 1500, 1700, 1500, 2000, 2100, 2000, 2000, 2400, 2000, 1800, 2300,
  1000, 2000, 1000, 2000, 1500, 1600, 2200, 1800, 1900, 1200, 1400, 1200, 1500,
  1600, 1700, 1400, 9000,
];
const goalData = [
  1300, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200, 3400, 3600, 3800,
  4000, 4200, 4400, 4600, 4800, 5000, 5200, 5400, 5600, 5800, 6000, 6200, 6400,
  6600, 6800, 7000, 7200,
]; //file: StorePlanning/store_planning.js
const dates = [
  "2022-10-01T18:30:00.000Z",
  "2022-10-02T18:30:00.000Z",
  "2022-10-03T18:30:00.000Z",
  "2022-10-04T18:30:00.000Z",
  "2022-10-05T18:30:00.000Z",
  "2022-10-06T18:30:00.000Z",
  "2022-10-07T18:30:00.000Z",
  "2022-10-08T18:30:00.000Z",
  "2022-10-09T18:30:00.000Z",
  "2022-10-10T18:30:00.000Z",
  "2022-10-11T18:30:00.000Z",
  "2022-10-12T18:30:00.000Z",
  "2022-10-13T18:30:00.000Z",
  "2022-10-14T18:30:00.000Z",
  "2022-10-15T18:30:00.000Z",
  "2022-10-16T18:30:00.000Z",
  "2022-10-17T18:30:00.000Z",
  "2022-10-18T18:30:00.000Z",
  "2022-10-19T18:30:00.000Z",
  "2022-10-20T18:30:00.000Z",
  "2022-10-21T18:30:00.000Z",
  "2022-10-22T18:30:00.000Z",
  "2022-10-23T18:30:00.000Z",
  "2022-10-24T18:30:00.000Z",
  "2022-10-25T18:30:00.000Z",
  "2022-10-26T18:30:00.000Z",
  "2022-10-27T18:30:00.000Z",
  "2022-10-28T18:30:00.000Z",
  "2022-10-29T18:30:00.000Z",
  "2022-10-30T18:30:00.000Z",
]; //file: StorePlanning/store_planning.js

const days = ["M", "T", "W", "T", "F", "S", "S"]; //file: Analytics/data.js and BusinessReportAdvanced/data.js

const Report = [
  {
    title: "Page views",
    subtitle: "Buy box percentage",
    value: "",
    percentvalue: null,
    percentage: null,
    sessionpercentage: 3,
  },
  {
    title: "Sessions",
    subtitle: "Sessions per view ratio",
    value: "",
    percentvalue: null,
    percentage: null,
    sessionpercentage: null,
  },
  {
    title: "Units order",
    subtitle: "Units per sessions rate",
    value: "",
    percentvalue: null,
    sessionpercentage: null,
    percentage: null,
    loss: "loss",
    gain: false,
    session: true,
  },
  {
    title: "Total order items",
    subtitle: "Items per sessions rate",
    value: "",
    percentvalue: null,
    percentage: null,
    sessionpercentage: null,
    loss: "loss",
    gain: "gain",
    session: true,
  },
]; //file: StoreProductDetails/Business.js

const keywordsList = [
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
  {
    flag: "USA flag",
    v1: "76.532",
    v2: "245.593",
    v3: "$1, 21",
    v4: "$72.451,04",
    v5: "4,56%",
    v6: "642",
    v7: "15,61%",
  },
]; // file: StoreProductKeywords/ListingTable.js

const sortAvailableFor = {
  "Units on the way": (row) =>
    "velocity" in row ? row["velocity"]["shipped_qty"] : "",
  "3PL Quantity": (row) => ("3pl" in row ? row["3pl"]["quantity"] : ""),
  "Available Inventory": (row) =>
    "fba_report" in row ? row["fba_report"]["available"] || 0 : 0,
  "FBA Quantity": (row) =>
    "fba_report" in row
      ? row["fba_report"]["quantity"] === "Soon"
        ? 0
        : row["fba_report"]["quantity"]
      : 0,
  "1 Month Forecast": (row) =>
    row[`demand_forcasting_1_months`] === "N/A"
      ? 0
      : row[`demand_forcasting_1_months`],
  "3 Months Forecast": (row) =>
    row[`demand_forcasting_3_months`] === "N/A"
      ? 0
      : row[`demand_forcasting_3_months`],
  "6 Months Forecast": (row) =>
    row[`demand_forcasting_6_months`] === "N/A"
      ? 0
      : row[`demand_forcasting_6_months`],
  "Days of Supply": (row) => row.days_of_supply?.visible || 0,
}; // file: StoreProducts/helpers.js

const sortAvailableType = {
  "Units on the way": "desc",
  "3PL Quantity": "desc",
  "Available Inventory": "desc",
  "FBA Quantity": "desc",
  "3 Months Forecast": "desc",
  "6 Months Forecast": "desc",
  "1 Month Forecast": "desc",
}; // file: StoreProducts/helpers.js

const columns = [
  "",
  "Days Left",
  "Actual",
  "Goal",
  "Actual vs. Goal",
  "Actual",
  "Goal",
  "Actual vs. Goal",
];

const defaultLevel1AdvancedReport = "Child ASIN";
const defaultLevel2AdvancedReport = "Select";
const defaultStoreProductAdvancedReport = {
  atlasonix: {
    sku: "BUBBLE_MIX_7",
    childAsin: "B07D8QFBK7",
    parentAsin: "B0CZ6Q7NMN",
  },
  duramont: {
    sku: "Desk chair",
    childAsin: "B0797HZ8W1",
    parentAsin: "B0797HZ8W1",
  },
  vos: {
    sku: "Vos-4",
    childAsin: "B0171BTJ84",
    parentAsin: "B0171BTJ84",
  },
  volko: {
    sku: "QN-EVS9-KB5W",
    childAsin: "B01M2A4IK1",
    parentAsin: "B01M2A4IK1",
  },
  buttertree: {
    sku: "MBP20",
    childAsin: "B08CSZHY2Z",
    parentAsin: "B08CSZHY2Z",
  },
  rushmorerose: {
    sku: "RRN3X5US",
    childAsin: "B01HMWWLCI",
    parentAsin: "B01N7C5DL4",
  },
  garnetics: {
    sku: "US Flag cover 52-55",
    childAsin: "B0B7S3S8H5",
    parentAsin: "B0B8C47WBV",
  },
  trueocity: {
    sku: "SUCTIONASSORTED",
    childAsin: "B07Y9L2N5Z",
    parentAsin: "B07Y9L2N5Z",
  },
};

const metricBackendNameToFrontendName = {
  sales: "Sales",
  units: "Units",
  units_b2b: "Units B2B",
  items: "Orders",
  items_b2b: "Orders B2B",
  sessions: "Sessions",
  conversion_rate: "Conversion Rate",
  avg_price: "Avg Price",
  spend_sp: "Spend SP",
  cpc_sp: "CPC SP",
  impressions_sp: "Impressions SP",
  clicks_sp: "Clicks SP",
  ctr_sp: "CTR SP",
  conversion_rate_samesku_sp: "Conversion Rate Same SKU SP",
  purchases_samesku_sp: "Purchases Same SKU SP",
  spend_display_ads: "Spend Display Ads",
  spend_brand: "Spend Brand",
  cpc_display_ads: "CPC Display Ads",
  impressions_display_ads: "Impressions Display Ads",
  clicks_display_ads: "Clicks Display Ads",
  ctr_display_ads: "CTR Display Ads",
  rate_display_ads: "Rate Display Ads",
  purchases_samesku_display_ads: "Purchases Same SKU Display Ads",
  net_margin: "Net Margin",
  net_profit: "Net Profit",
  needed_velocity: "Needed Velocity",
};

const metricValues = [
  "sales",
  "units",
  "units_b2b",
  "items",
  "items_b2b",
  "sessions",
  "conversion_rate",
  "avg_price",
  "spend_sp",
  "cpc_sp",
  "impressions_sp",
  "clicks_sp",
  "ctr_sp",
  "conversion_rate_samesku_sp",
  "purchases_samesku_sp",
  "spend_display_ads",
  "spend_brand",
  "cpc_display_ads",
  "impressions_display_ads",
  "clicks_display_ads",
  "ctr_display_ads",
  "rate_display_ads",
  "purchases_samesku_display_ads",
  "net_margin",
  "net_profit",
  "needed_velocity",
];
const defaultPeriodicity = "day";
const defaultIsClient = "false";
const LOGOUT_ROUTE = "/auth/sign-in";

// Agent identity registry — single source of truth for display info (name,
// color, avatar) shared by the Agents screen and the Store Analysis
// multicard, so both surfaces stay in sync automatically.
// Dave doesn't sense his own decisions in Stage 1 (no decision row of his
// own) — he's an attribution facet layered on top of whichever agent's row
// carries an unresolved deal offer, see decisionHasActiveDeal below.
const AGENT_INFO = {
  iris: { name: "Iris", color: "#9c27b0", avatar: "/assets/iris.png" },
  pete: { name: "Pete", color: "#2196f3", avatar: "/assets/pete.png" },
  ross: { name: "Ross", color: "#ff9800", avatar: "/assets/ross.png" },
  sam: { name: "Sam", color: "#4caf50", avatar: "/assets/sam.png" },
  regina: { name: "Regina", color: "#c62828", avatar: "/assets/regina.png" },
  dave: { name: "Dave", color: "#00897b", avatar: "/assets/dave.png" },
  // Rita recommends AWD → FBA replenishment (feature_store agent_rita). Her
  // decisions carry no target price: decision_type "inventory".
  rita: { name: "Rita", color: "#8d6e63", avatar: "/assets/rita.png" },
  // Fiona suggests packaging (or US price) changes that lower the FBA fee.
  // Suggestions only: she never changes anything on Amazon.
  fiona: { name: "Fiona", color: "#3949ab", avatar: "/assets/fiona.png" },
};

// Where Rita's cards send the seller: the Seller Central FBA Inventory page,
// whose "Move from AWD" button (top right) creates a replenishment order from
// AWD to FBA. Same page data_collector's AWD report scraper opens daily, so
// it is known to exist. AWD is US-only, so the .com domain is fixed.
const AWD_SELLER_CENTRAL_URL =
  "https://sellercentral.amazon.com/fba-inventory/gim/inventory-list?ref=fbacentral_nav_fba";

// Classifies a rule-engine decision by its sensing agent (the one that
// produced the row). Never returns "dave" — see decisionHasActiveDeal.
const getAgentKey = (decision) => {
  const agentName = decision.decision?.agent?.toLowerCase();
  if (agentName === "sam" || decision.decision_type === "sam") return "sam";
  if (agentName === "ross" || decision.version?.includes("ross")) return "ross";
  if (agentName === "regina" || decision.version?.includes("regina"))
    return "regina";
  if (agentName === "pete") return "pete";
  if (agentName === "rita" || decision.version?.includes("rita")) return "rita";
  if (agentName === "fiona" || decision.version?.includes("fiona"))
    return "fiona";
  return "iris";
};

// Fiona's FBA-fee cards (decision_type "fee_optimization"). Answered through
// /fiona-cards, never through the Iris price flow.
const isFionaDecision = (decision) => getAgentKey(decision) === "fiona";

// A Fiona card priced on the next published fee schedule (card_group
// "fiona_preview", with decision.effective_date) rather than today's fees.
const isFionaPreviewDecision = (decision) =>
  isFionaDecision(decision) &&
  decision?.decision?.card_group === "fiona_preview";

// Biggest yearly saving first, cards without one (no sales in the last 90
// days) last, ties broken on the per-unit saving.
const compareFionaSavings = (a, b) => {
  const annualA = a?.decision?.annual_savings;
  const annualB = b?.decision?.annual_savings;
  if ((annualA == null) !== (annualB == null)) return annualA == null ? 1 : -1;
  if (annualA != null && annualA !== annualB) return annualB - annualA;
  return (b?.decision?.savings ?? 0) - (a?.decision?.savings ?? 0);
};

// A decision "belongs to Dave" alongside its sensing agent when it carries
// an unresolved deal offer — Dave filters/badges are additive, not
// exclusive of the sensing agent's own filter/badge.
const decisionHasActiveDeal = (decision) =>
  !!(decision?.deal_available && decision?.deal);

// Identifies one specific deal offer for local-only reject tracking.
// `execution_id` alone isn't safe here — it can repeat across ASINs (a
// batch rule-engine run) or come back empty, which would make rejecting
// one deal look like rejecting every decision sharing that id. Folding in
// the asin and the deal's own id keeps the key unique per offer.
const getDealKey = (decision) =>
  `${decision?.asin || ""}|${decision?.execution_id || ""}|${
    decision?.deal?.deal_id || decision?.deal?.id || ""
  }`;

// Every active store tagged tier=internal in the stores AppConfig. The set does
// not change, so it is listed here rather than carried in the login payload.
const INTERNAL_STORES = [
  "atlasonix",
  "atomicuk",
  "buttertree",
  "duramont",
  "garnetics",
  "roofpax",
  "rushmorerose",
  "trueocity",
  "volko",
  "vos",
  "yogi",
];

// Mirrors the backend's atomic_goals_stores: the Atomic-owned stores in the
// goals budget (db_name 'atomic-data', minus buttertree and atomicuk).
const GOALS_PORTFOLIO_STORES = [
  "atlasonix",
  "duramont",
  "garnetics",
  "roofpax",
  "rushmorerose",
  "trueocity",
  "volko",
  "vos",
  "yogi",
];

// How many days past today the velocity tool targets are requested for and
// shown in the products table.
const VELOCITY_TOOL_EXTRA_DAYS = 7;

// The window summary panel shows from this many days before a velocity tool
// window starts until this many days after it ends.
const VELOCITY_WINDOW_PANEL_MARGIN_DAYS = 7;

// Ross's automatic revert of an Iris price increase (card_group "ross_revert").
// Informational — the price change already happened (or failed to) — unlike
// his velocity-analysis card, which shares agent "ross" and decision_type
// "price" and must keep its own rendering.
const isRossRevertDecision = (decision) =>
  decision?.decision?.agent?.toLowerCase() === "ross" &&
  decision?.informational === true &&
  (decision?.decision?.action === "Price Reverted" ||
    decision?.decision?.card_group === "ross_revert");

// Ross's "Price Kept" outcome (card_group "ross_sticky"): after an automatic
// Iris increase, sales held up, so the higher price stays. Informational —
// nothing is executed, so it carries no automated_execution_status.
const isRossPriceKeptDecision = (decision) =>
  decision?.decision?.agent?.toLowerCase() === "ross" &&
  decision?.informational === true &&
  (decision?.decision?.action === "Price Kept" ||
    decision?.decision?.card_group === "ross_sticky");

// Ross's velocity analysis (rule VelocityAfterAcceptance) when he finds that
// the recommendation the seller accepted was never actually applied: same
// payload as the regular analysis, but performance_score / impact_label
// "Not Implemented". Nothing to measure or act on, so it's shown as an FYI
// in the agents view only (Store Analysis hides Ross analyses altogether).
const isRossNotImplementedDecision = (decision) =>
  decision?.decision?.agent?.toLowerCase() === "ross" &&
  [decision?.decision?.performance_score, decision?.decision?.impact_label]
    .map((v) => (v || "").toLowerCase())
    .includes("not implemented");

// Iris's Reduce PPC cards (decision_type "ppc_pause" / "ppc_done"): to slow
// sales she pauses the Sponsored Products ads with the highest ACoS instead
// of raising the price, summed up by the backend in `ppc_card`. One of:
// - "awaiting": she needs the seller's OK before pausing them
// - "manual": she tried, but Amazon Ads left some of them enabled
// - "applied": the ads are paused
// - "reverted": they were paused, and turned back on once stock recovered
// - "pending": automation still running, not shown until it settles
// - null: not a PPC card. A "price_instead" ppc_card is a regular Iris price
//   card (the PPC lever wasn't possible) and keeps the price rendering.
const getIrisPpcState = (decision) => {
  const card = decision?.ppc_card;
  if (card?.kind === "awaiting_approval") return "awaiting";
  if (card?.kind !== "done_for_you") return null;
  if (card.status === "applied") return "applied";
  if (card.status === "reverted") return "reverted";
  if (
    ["partially_applied", "failed", "all_attempts_failed"].includes(card.status)
  ) {
    return "manual";
  }
  return "pending";
};

const isIrisPpcDecision = (decision) => getIrisPpcState(decision) !== null;

// Decisions the system already executed on the seller's behalf, shown in the
// "Done for you" section instead of as actionable cards.
const isDoneForYouDecision = (decision) =>
  (decision?.automated_execution_status === "succeeded" &&
    (decision?.decision?.agent?.toLowerCase() === "iris" ||
      isRossRevertDecision(decision))) ||
  ["applied", "reverted"].includes(getIrisPpcState(decision));

module.exports = {
  storesEmails,
  storeToOwnerEmail,
  storeNames,
  filters,
  sort_by_list,
  presets,
  dateRanges,
  compareToValues,
  months,
  labels,
  actualData,
  forecastData,
  goalData,
  dates,
  days,
  Report,
  keywordsList,
  sortAvailableFor,
  sortAvailableType,
  columns,
  defaultLevel1AdvancedReport,
  defaultLevel2AdvancedReport,
  defaultStoreProductAdvancedReport,
  defaultPeriodicity,
  defaultIsClient,
  LOGOUT_ROUTE,
  metricValues,
  metricBackendNameToFrontendName,
  AuthorizedStores,
  isAtomicUser,
  storesWithEuMarketplaces,
  storesUkOnly,
  AGENT_INFO,
  AWD_SELLER_CENTRAL_URL,
  getAgentKey,
  isFionaDecision,
  isFionaPreviewDecision,
  compareFionaSavings,
  decisionHasActiveDeal,
  getDealKey,
  GOALS_PORTFOLIO_STORES,
  INTERNAL_STORES,
  isRossRevertDecision,
  isRossPriceKeptDecision,
  isRossNotImplementedDecision,
  getIrisPpcState,
  isIrisPpcDecision,
  isDoneForYouDecision,
  VELOCITY_TOOL_EXTRA_DAYS,
  VELOCITY_WINDOW_PANEL_MARGIN_DAYS,
};
